export const MAX_COMMENTS_PER_PAGES = 20
